<template>
  <div class="container default-container">
    <hr class="mt-0">
    <div class="row">
      <div class="col-6">
        <img
          src="@/assets/workwithus-hero.jpg"
          class="hero-img"
        >
      </div>
      <div class="col-6 mx-auto">
        <div class="narrow m-auto">
          <img
            src="@/assets/planetajob_logo_dark.png"
            style="width: 90%"
          >
          <div class="text-center mt-3">
            <h2 class="--bold">
              {{ $t('pages.workwithus.title') }}
            </h2>
            <div
              style="width: 65%"
              class="m-auto mt-2"
            >
              <div>{{ $t('pages.workwithus.subtitle-1') }}</div>
              <div>{{ $t('pages.workwithus.subtitle-2') }}</div>
            </div>
          </div>
          <div class="form text-left mt-2">
            <div
              role="group"
              class="mb-3"
            >
              <label
                for="input-live"
                class="mb-0"
              >
                {{ $t('inputs.first-name.title') }}
                <span class="required-asterix">*</span>
              </label>
              <b-form-input
                id="input-live"
                v-model="$v.form.name.$model"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                aria-describedby="input-live-help input-live-feedback"
                trim
              />
            </div>
            <div
              role="group"
              class="mb-3"
            >
              <label
                for="input-live"
                class="mb-0"
              >
                {{ $t('inputs.email.title-full') }}
                <span class="required-asterix">*</span>
              </label>
              <b-form-input
                id="input-live"
                v-model="$v.form.email.$model"
                :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                aria-describedby="input-live-help input-live-feedback"
                trim
              />
            </div>
            <div
              role="group"
              class="mb-3"
            >
              <label
                for="input-live"
                class="mb-0"
              >
                {{ $t('pages.workwithus.cv') }}
                <span class="required-asterix">*</span>
              </label>
              <b-form-file
                v-model="$v.form.file.$model"
                :state="$v.form.file.$dirty ? !$v.form.file.$error : null"
                :placeholder="$t('pages.workwithus.select-file', 'Select a file')"
                :drop-placeholder="$t('pages.workwithus.drop-file', 'Drop file here...')"
                :browse-text="$t('generic.browse', 'Browse')"
              />
              <span
                style="font-size: 0.7rem; color: #666"
              >{{ $t('pages.workwithus.requirements', '*Max. 2MB, .pdf') }}</span>
              <b-form-invalid-feedback
                :state="$v.form.file.$model === null ? !$v.form.file.$error : null"
              >
                {{ $t('pages.workwithus.please-select-file', 'Please select a document') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                :state="$v.form.file.$dirty && $v.form.file.$model != null ? !$v.form.file.$error : null"
              >
                {{ $t('pages.workwithus.invalid-file', 'Selected document does not meet the requirements') }}
              </b-form-invalid-feedback>
            </div>
            <b-button
              class="custom-send-btn mt-2"
              @click="sendForm()"
            >
              {{ $t('generic.send') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

const lessThanTwoMb = (value) => {
  if (!value) return false;
  else return value.size <= 2 * 1000 * 1000;
};
const goodFileFormat = (value) => {
  if (!value) return false;
  else {
    return (
      value.type === "application/pdf"
    );
  }
};

export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        file: null,
      },
      uploadPercentage: 0
    };
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      file: { required, lessThanTwoMb, goodFileFormat }
    }
  },
  methods: {
    sendForm() {

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastNotification('danger', '', this.$t('pages.offer-apply.alert.correct-errors', 'Please correct the errors in the form'));
        return false;
      } else {
        const fd = new FormData();
        fd.append('file', this.form.file);
        fd.append('email', this.form.email);
        fd.append('name', this.form.name);

        this.axios
          .post("/work-with-us/form", fd, {
            headers: {
            'Content-type': 'multipart/form-data'
            },
            onUploadProgress: function( progressEvent ) {
              this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
            }.bind(this)
          })
          .then((response) => {
            console.log(response);
          })
          .catch();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.narrow {
  width: 80%;
}

.hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom-send-btn {
  width: 100%;
  padding-top: 9px;
  padding-bottom: 9px;
  background: #ff6340;
  border: #ff6340;
}

.required-asterix {
  color: red;
}
</style>